import { create } from 'zustand';
import { emailTemplatesApi } from '../lib/api';
import type { EmailTemplate } from '../types/campaign';

interface EmailTemplateState {
  templates: EmailTemplate[];
  isLoading: boolean;
  error: string | null;
  fetchTemplates: () => Promise<void>;
  saveTemplate: (body: Partial<EmailTemplate>, id?: string) => Promise<EmailTemplate | null>;
}

export const useEmailTemplateStore = create<EmailTemplateState>((set) => ({
  templates: [],
  isLoading: false,
  error: null,
  fetchTemplates: async () => {
    set({ isLoading: true, error: null });
    try {
      const templates = await emailTemplatesApi.list();
      set({ templates, isLoading: false });
    } catch (e) {
      set({ error: e instanceof Error ? e.message : 'Failed to load templates', isLoading: false });
    }
  },
  saveTemplate: async (body, id) => {
    try {
      return id ? await emailTemplatesApi.update(id, body) : await emailTemplatesApi.create(body);
    } catch (e) {
      set({ error: e instanceof Error ? e.message : 'Failed to save template' });
      return null;
    }
  },
}));
